class GiftCardSelector {
    constructor (theme, elem) {
        this._name = this.constructor.name
        this._elem = elem
        this._swatchContainer = this._elem.querySelector('.giftcard-swatches')
        this._swatches = this._swatchContainer.querySelectorAll('input[type="radio"]')
        this._button = this._elem.querySelector('.giftcard-buy a')
    }
    onInit () {
        this.updateButton()
        for (var i = 0; i < this._swatches.length; i++) {
            this._swatches[i].addEventListener('change', (e) => {
                const id = e.currentTarget.value
                this.updateButton(id)
            })
            if (this._swatches[i].checked) {
                this.updateButton(this._swatches[i].value)
            }
        }
    }
    updateButton (id) {
        if (id) {
            this._button.innerHTML = 'Buy Now'
            this._button.href = '/cart/' + id + ':1'
            this._button.classList.remove('buy-disabled')
        } else {
            this._button.innerHTML = 'Select a Gift Card'
            this._button.removeAttribute('href')
            this._button.classList.add('buy-disabled')
        }
    }
}
export default GiftCardSelector



// WEBPACK FOOTER //
// ./resources/scripts/components/GiftCardSelector.js